import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { K_MOBILE_SIZE } from "constants.js";
import useWindowSize from "hooks/useWindowSize";

const TypeWriter = (props) => {
  const { text, style, speed, delay } = props;
  const { width } = useWindowSize();

  const styles = {
    ...pcStyles,
    ...(width < K_MOBILE_SIZE ? mobileStyles : {}),
  };
  const [displayText, setDisplayText] = useState("");
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsRunning(true);
    }, delay);
  }, [delay]);

  useEffect(() => {
    if (isRunning) {
      if (displayText !== text) {
        setTimeout(() => {
          setDisplayText(text.substring(0, displayText.length + 1));
        }, speed);
      }
    }
  }, [text, displayText, speed, isRunning]);

  return (
    <div style={styles.container}>
      <h1 style={style}>{displayText}</h1>
    </div>
  );
};

const pcStyles = {
  container: {
    minHeight: "5rem",
    margin: "1.5rem",
  },
};

const mobileStyles = {
  container: {
    minHeight: "5rem",
    margin: "0.5rem",
  },
};

TypeWriter.propTypes = {
  text: PropTypes.string.isRequired,
  style: PropTypes.shape().isRequired,
  speed: PropTypes.number.isRequired,
  delay: PropTypes.number.isRequired,
};

export default TypeWriter;
